import { Backdrop, CircularProgress } from '@mui/material';
import { useAppSelector } from '../../store/hooks';

const Loader = () => {
  const showBackdrop = useAppSelector((state) => state.ui.showBackdrop);

  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
      open={showBackdrop}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loader;
